import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "./StatusButton.css";

const { t } = new Translate("StatusButton");

const StatusButton = (props) => (
  <button className={classnames(styles.root, styles[props.type])} onClick={props.onClick}>
    {t(props.type)}
  </button>
);

StatusButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["disregard", "execute"]).isRequired,
};

export default StatusButton;
